import React from 'react';
import { TxState } from '../../hooks/usePredictionMarket';

interface TxToastProps {
  tx: TxState;
  onDismiss: () => void;
}

const ETHERSCAN_BASE = 'https://sepolia.etherscan.io/tx/';

export default function TxToast({ tx, onDismiss }: TxToastProps) {
  if (tx.status === 'idle') return null;

  const cls =
    tx.status === 'pending'
      ? 'tx-toast tx-toast-pending'
      : tx.status === 'success'
      ? 'tx-toast tx-toast-success'
      : 'tx-toast tx-toast-error';

  return (
    <div className={cls} role="alert">
      <span className="tx-toast-icon">
        {tx.status === 'pending' && '⏳'}
        {tx.status === 'success' && '✅'}
        {tx.status === 'error' && '❌'}
      </span>
      <span className="tx-toast-msg">
        {tx.status === 'pending' && 'Transaction pending…'}
        {tx.status === 'success' && 'Transaction confirmed!'}
        {tx.status === 'error' && (tx.error || 'Transaction failed')}
      </span>
      {tx.hash && (
        <a
          className="tx-toast-link"
          href={`${ETHERSCAN_BASE}${tx.hash}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          View on Etherscan ↗
        </a>
      )}
      {tx.status !== 'pending' && (
        <button className="tx-toast-close" onClick={onDismiss} aria-label="Dismiss">
          ×
        </button>
      )}
    </div>
  );
}
